import { isBagSurcharge } from 'features/cart/utils/server-order-surcharges';

import { IFee, IServerOrder } from '@rbi-ctg/menu';

import { FEES } from './constants';
import { IGetStandardizedName } from './types';

type FeeFields = Partial<Omit<IFee, 'name' | 'totalCents'>> & {
  readonly name?: IFee['name'] | null;
  readonly totalCents?: IFee['totalCents'] | null;
};

type FeeLike = FeeFields | null | undefined;

export const getStandardizedName = ({ name }: IGetStandardizedName) =>
  (FEES as Record<string, string>)[name] ?? name;

export const getFeesByGroup = (
  fees?: ReadonlyArray<FeeLike> | null,
  enablePosOrderSurchargesAsFees = false
) => {
  return (fees ?? []).reduce<Record<string, number>>((acc, val) => {
    if (enablePosOrderSurchargesAsFees && isBagSurcharge(val)) {
      return acc;
    }

    if (!val?.name || !val.totalCents) {
      return acc;
    }

    const lowerCaseName = val.name.toLowerCase();
    acc[lowerCaseName] = (acc[lowerCaseName] ?? 0) + val.totalCents;

    return acc;
  }, {});
};

enum DONATIONS {
  ROUND_UP = '',
}

export const getRoundUpDonations = (serverOrder: IServerOrder | null) =>
  serverOrder?.cart?.donations?.find(({ name }) => name === DONATIONS.ROUND_UP);
